import React from 'react';

import MsgScreen from '../../@packages/@bd-uikit-web/React/MsgScreen';
import NotiBanner from '../../@packages/@bd-uikit-web/React/NotiBanner';
import { connect } from 'react-redux';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import rootDispatcher from '../../@packages/@bd-uikit-web/js-helpers/rootDispatcher';
import store from 'store';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';

export class App extends React.Component {
  constructor() {
    super();

    this.state = {
      user: bdAuth.getUser() || {},
      loading: true,
      submitting: false,
      showArtworkNotAvailableModal: false,
      showSubscribeModal: false,
      go: 1,
      showNoticeBar: true
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    switch (e.which) {
      case 4:
        this.props.history.push(`/info-page`);
        break;
      case 111:
        this.props.history.goBack();
        break;
    }
  }

  render() {
    return (
      <div className="full-size" onKeyDown={this.handleClick}>
        {this.state.showNoticeBar ? <NotiBanner /> : null}
        {
          this.props.children
        }
      </div>
    );
  }
}

export default connect((state) => {
  const { history } = state;
  return {
    history
  }
})(App);
